<app-otp-resume-application *ngIf="EnableResumeOTPPage" [mobileNumber]="mobileNumber"></app-otp-resume-application>
<section *ngIf="showLoader">
    <app-loader></app-loader>
</section>
<custom-popup [config]="Config" [title]="''" [showClose]="false" [subtitle]="''" [id]="'sessionupdate'">
    <div class="modal-body height-medium">
        <div class="clearfix">
            <div class="col-xs-12 col-md-12">
                <h5 class="margin-bottom-only-20 bold-text font-bold text-center">
                    {{snatchSession}}
                </h5>
                <div class="col-xs-12 col-md-12 text-center">
                    <button type="button" class="btn btn-primary btn-single" (click)="proceedNext(true)">
                        <strong class="btn-txt"> OK
                        </strong>
                    </button>
                    <button type="button" class="btn btn-primary btn-single btn-responsive-spacing" (click)="proceedNext(false)">
                        <strong class="btn-txt"> Cancel
                        </strong>
                    </button>
                </div>
            </div>
        </div>
    </div>
</custom-popup>